import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ErrorService } from '../../error';
import { ListItem } from '../typeahead/types';

/** The endpoint caps the list at 10 by default: ask for more than the groups that exist. */
const GROUP_LIST_ITEM_PAGE_SIZE = 100;

@Injectable({
  providedIn: 'root',
})
export class GroupApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  getListItem = (): Observable<ListItem[]> => {
    let url = this.formatUrl(['listItem']);
    const params = new HttpParams().append(
      'pageSize',
      GROUP_LIST_ITEM_PAGE_SIZE,
    );

    return this.httpClient.get<ListItem[]>(url, { params }).pipe(
      catchError((error) => {
        throw this.errorService.serverErrorRedirect(error);
      }),
    );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.group.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
